const ReturnThesis = {
  queryList: [],
  urlMap: {
    'select': {
      url: '/exp/expReviewInfo/queryReviewList',
      data: {
        acceptStatus: 4
      }
    }
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'firstSubjectName',
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      label: '二级学科'
    },
    {
      name: 'researchAera',
      label: '论文涉及的研究方向'
    },
    {
      name: 'titleCn',
      label: '论文题目'
    },
    {
      name: 'titleEn',
      label: '论文英文题目'
    },
    {
      name: 'receiveTime',
      label: '退回时间'
    }
  ],
  legent: []
}
export default ReturnThesis



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/returnThesis.js